export const url = "https://kavishkamk.live/api";
